import React from 'react';
import { Excalidraw } from "@excalidraw/excalidraw";

const Whiteboard = () => {
  return (
    <div style={{ height: "500px", width: "100%" }}>
      <Excalidraw />
    </div>
  );
};

export default Whiteboard;
